import { render } from "./CustomDialogGuangDong.vue?vue&type=template&id=c7d8637a&scoped=true&ts=true"
import script from "./CustomDialogGuangDong.vue?vue&type=script&lang=ts"
export * from "./CustomDialogGuangDong.vue?vue&type=script&lang=ts"

import "./CustomDialogGuangDong.vue?vue&type=style&index=0&id=c7d8637a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d8637a"]])

export default __exports__